var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-centerForm",
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: "",
                    model: _vm.searchForm,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付流水号", prop: "flowNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入支付流水号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.flowNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "flowNo", $$v)
                          },
                          expression: "searchForm.flowNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "业务ID", prop: "businessId" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入业务ID（订单号）",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.businessId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "businessId", $$v)
                          },
                          expression: "searchForm.businessId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "业务类型", prop: "businessType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择业务类型",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.businessType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "businessType", $$v)
                            },
                            expression: "searchForm.businessType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "tinggo机票", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "51kongtie机票", value: "2" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付平台", prop: "payPlatform" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择支付平台",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.payPlatform,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "payPlatform", $$v)
                            },
                            expression: "searchForm.payPlatform",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "2c2p", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "airwallex", value: "2" },
                          }),
                          _c("el-option", {
                            attrs: { label: "cash", value: "3" },
                          }),
                          _c("el-option", {
                            attrs: { label: "wechat", value: "4" },
                          }),
                          _c("el-option", {
                            attrs: { label: "alipay", value: "5" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "币种", prop: "currencyCode" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入币种", clearable: "" },
                        model: {
                          value: _vm.searchForm.currencyCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "currencyCode", $$v)
                          },
                          expression: "searchForm.currencyCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付状态", prop: "payStatus" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择支付状态",
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchForm.payStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "payStatus", $$v)
                            },
                            expression: "searchForm.payStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "待支付", value: 0 },
                          }),
                          _c("el-option", {
                            attrs: { label: "支付中", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "成功", value: 2 },
                          }),
                          _c("el-option", {
                            attrs: { label: "失败", value: 3 },
                          }),
                          _c("el-option", {
                            attrs: { label: "超时", value: 4 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.searchForm.addTimeRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "addTimeRange", $$v)
                          },
                          expression: "searchForm.addTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付完成时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.searchForm.payFinishTimeRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "payFinishTimeRange", $$v)
                          },
                          expression: "searchForm.payFinishTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "search-buttons" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: { click: _vm.search },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh-left" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.refresh },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "v-tableEncapsulation",
        {
          attrs: {
            loading: _vm.loadingBtn.tableLoading,
            columnData: _vm.columnData,
            tableSize: _vm.pagination.size,
            tableData: _vm.tableData,
            tableTotal: _vm.pagination.total,
            currentPage: _vm.pagination.current,
          },
          on: {
            currentPage: _vm.handleCurrentChange,
            sizeChange: _vm.handleSizeChange,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              slot: "payStatus",
              label: "支付状态",
              align: "center",
              width: "100px",
            },
            slot: "payStatus",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getPayStatusTagType(scope.row.payStatus),
                          effect: "dark",
                        },
                      },
                      [_vm._v(" " + _vm._s(scope.row.payStatusText) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              slot: "operate",
              label: "操作",
              align: "center",
              width: "100px",
              fixed: "right",
            },
            slot: "operate",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.viewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "交易记录详情",
            visible: _vm.detailDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.transactionDetail.flowNo
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "支付流水号" } },
                    [_vm._v(_vm._s(_vm.transactionDetail.flowNo))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "业务ID" } }, [
                    _vm._v(_vm._s(_vm.transactionDetail.businessId)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "业务类型" } }, [
                    _vm._v(_vm._s(_vm.transactionDetail.businessTypeText)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付平台" } }, [
                    _vm._v(_vm._s(_vm.transactionDetail.payPlatformText)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "币种" } }, [
                    _vm._v(_vm._s(_vm.transactionDetail.currencyCode)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付金额" } }, [
                    _vm._v("$" + _vm._s(_vm.transactionDetail.amount)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付模式" } }, [
                    _vm._v(_vm._s(_vm.transactionDetail.payMode)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "支付状态" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getPayStatusTagType(
                              _vm.transactionDetail.payStatus
                            ),
                            effect: "dark",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.transactionDetail.payStatusText) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "资金商户ID" } },
                    [_vm._v(_vm._s(_vm.transactionDetail.cashCustId))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "资金商户名称" } },
                    [_vm._v(_vm._s(_vm.transactionDetail.cashCustName))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "资金交易编码" } },
                    [_vm._v(_vm._s(_vm.transactionDetail.cashTradeNo))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "资金交易流水号" } },
                    [_vm._v(_vm._s(_vm.transactionDetail.cashTradeLiushuihao))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "支付完成时间" } },
                    [_vm._v(_vm._s(_vm.transactionDetail.payFinishTime || "-"))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                    _vm._v(_vm._s(_vm.transactionDetail.addTime)),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }